import { Fragment } from 'react'

import {
  ChildrenDocument,
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  DocumentFolder,
  FolderName,
  PERMITBOOK_DOCUMENTS,
} from '../../models/document'
import { DocumentRow } from './DocumentRow'

interface DocumentRowsProps {
  folder: DocumentFolder
  refetchDocuments: () => Promise<any>
  displayFolders: FolderName[]
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function DocumentRows({
  folder,
  refetchDocuments,
  displayFolders,
  onDocumentOpen,
  renderDocumentAction,
}: DocumentRowsProps) {
  return (
    <>
      {folder.childrenDocumentsPresent.map(
        (document, id) =>
          PERMITBOOK_DOCUMENTS.includes(document.documentType) && (
            <DocumentRow
              key={`document-row-present-${id}`}
              document={document}
              displayFolders={displayFolders}
              onDocumentOpen={onDocumentOpen}
              renderDocumentAction={renderDocumentAction}
              refetchDocuments={refetchDocuments}
            />
          )
      )}
      {folder.childrenDocumentsMissing.map(
        (document, id) =>
          PERMITBOOK_DOCUMENTS.includes(document.documentType) && (
            <DocumentRow
              key={`document-row-missing-${id}`}
              document={document}
              displayFolders={displayFolders}
              onDocumentOpen={onDocumentOpen}
              renderDocumentAction={renderDocumentAction}
              refetchDocuments={refetchDocuments}
            />
          )
      )}
      {folder.childrenFolders.map((folder, id) => (
        <DocumentRows
          key={`document-rows-${id}`}
          folder={folder}
          displayFolders={displayFolders}
          onDocumentOpen={onDocumentOpen}
          renderDocumentAction={renderDocumentAction}
          refetchDocuments={refetchDocuments}
        />
      ))}
    </>
  )
}
